import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { METADATA_FILE_NAME } from '../../utils/constants';

const useDatasetsMetadata = () => {
    const metadata = useQuery({
        queryKey: ['datasetsMetadata'],
        queryFn: async () => {
            const { data } = await axios.get(
                `${process.env.REACT_APP_CLOUDFRONT_URL}/${METADATA_FILE_NAME}`
            );
            return data;
        },
    });
  
    return metadata;
};

export default useDatasetsMetadata;
